let timeHandler = null;
var LimitFunction = function( fun , wait ){
  if( timeHandler )
    clearTimeout(timeHandler);

    timeHandler = setTimeout( fun, wait );

}
export default LimitFunction;
